import RecievedMessage from "./RecievedMessage";

export default RecievedMessage